// extracted by mini-css-extract-plugin
export default {"EditButton":"EditButton_EditButton__5-Rev"};